export default __webpack_public_path__ + "static/media/Orpheus.e393292d.woff";